import Vue from "vue";

export default {
    recuperarSituacoesInscricao() {
        return Vue.axios.get("situacaoInscricao");
    }
};
